(function () {
  'use strict';

  /* @ngdoc object
   * @name vcdms.vcpdfprinter
   * @description
   *
   */
  angular
    .module('vcdms.vcpdfprinter', [
    ]);
}());
